<template>
	<TutorialInterfaceItem :isShowing="isShowing">
		<FoodBag slot="component" />
	</TutorialInterfaceItem>
</template>

<script>
import FoodBag from '@/components/board/FoodBag';
import TutorialInterfaceItem from '@/components/tutorial/TutorialInterfaceItem';
import tooltips from '@/mixins/tooltips';

export default {
	name: 'TutorialFoodBag',
	mixins: [tooltips],
	components: {
		FoodBag,
		TutorialInterfaceItem,
	},
	computed: {
		isShowing() {
			return this.tooltipLocation === "foodBag" && this.tooltipShowing;
		},
	},
	watch: {
		tooltipLocation(newLocation, oldLocation) {
			if (newLocation !== oldLocation) {
				this.showTooltip();
			}
		},
	},

};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/tutorial/TutorialFoodBag.vue